const isZeroOrPositiveInteger = candidate =>
  Number.isInteger(candidate) && candidate >= 0;

export default isZeroOrPositiveInteger;
